import { useRef } from 'react';
import { useStableFunction } from '../../core/hooks/use-stable-function';
import { Event, track } from './track';

/**
 * Record analytics event only once per component lifecycle.
 * @param event
 */
export function useTrackOnce(event: Event) {
  const hasTrackedRef = useRef(false);
  return useStableFunction(() => {
    if (hasTrackedRef.current) {
      return;
    }
    hasTrackedRef.current = true;
    track(event);
  });
}
